import { cn } from '@/client/utils';

export const Skeleton = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div 
      className={cn(
        'relative overflow-hidden rounded-md bg-foreground/5',
        // Shimmer animation
        'before:absolute before:inset-0',
        'before:-translate-x-full before:animate-shimmer',
        'before:bg-gradient-to-r before:from-transparent before:via-foreground/5 before:to-transparent',
        className
      )} 
      {...props} 
    />
  );
};

